import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { UiNodeSpec } from './UiNodeSpec';

export const udpSocketUiNodeSpec: UiNodeSpec<'udpSocket'> = {
    requiredSockets: (node, availableInputSockets, availableOutputSockets) => ({
        required: [],
        conditionallyRequired: [
            {
                kind: 'or',
                availableOptions: [ ...availableInputSockets, ...availableOutputSockets ],
            },
        ],
    }),
    cfg: () => ({
        disabled: false,
        controlValues: {
            bindAddress: '0.0.0.0',
            bindPort: 1234,
            connectToAddress: '',
            connectToPort: 5678,
            encoding: 'utf8',
        },
        id: getUID(),
        kind: 'udpSocket',
    }),
    controls: getNodeCfg => ({
        bindAddress: { cfg: { kind: 'text', label: 'Bind Address' }, nodeCfg: getNodeCfg(), value: getNodeCfg().controlValues.bindAddress },
        bindPort: { cfg: { kind: 'number', label: 'Bind Port' }, nodeCfg: getNodeCfg(), value: getNodeCfg().controlValues.bindPort },
        connectToAddress: { cfg: { kind: 'text', label: 'Connect To Address', optional: true }, nodeCfg: getNodeCfg(), value: getNodeCfg().controlValues.connectToAddress },
        connectToPort: { cfg: { kind: 'number', label: 'Connect To Port', optional: true }, nodeCfg: getNodeCfg(), value: getNodeCfg().controlValues.connectToPort },
        encoding: {
            cfg: {
                items: [
                    { label: 'UTF-8', value: 'utf8' },
                    { label: 'Hex', value: 'hex' },
                    { label: 'Ascii', value: 'ascii' },
                ],
                kind: 'selection',
                label: 'Encoding',
            },
            nodeCfg: getNodeCfg(),
            value: getNodeCfg().controlValues.encoding,
        },
    }),
    inputs: nodeCfg => ({
        inputTrigger: { socket: 'event', label: 'Send Trigger' },
        sendPayload: {
            control: {
                cfg: { kind: 'text', nullable: true, label: 'Send Payload' },
                nullable: true,
                nodeCfg,
                value: nodeCfg.socketDefaults?.inputs?.sendPayload,
            },
            socket: 'string',
        },
    }),
    kindLabel: 'UDP Socket',
    nodeCategory: 'external',
    outputs: () => ({
        onReceivedTrigger: { socket: 'event', label: 'On Received' },
        onSentTrigger: { socket: 'event', label: 'On Send' },
        receivePayload: { socket: 'string', label: 'Received Payload' },
    }),
    validator: node => {
        const errors: Record<string, string> = {};
        if (!node.controlValues.bindAddress) {
            errors.bindAddress = 'Bind address is required';
        }
        if (!node.controlValues.bindPort) {
            errors.bindPort = 'Bind port is required';
        }
        return Object.keys(errors).length ? errors : true;
    },
};
